<template>
  <div class="container-wrapper">
    <div class="title">
      {{title}}
      <hr>
    </div>
    <BenchmarksTooltipInfo
      v-for="info in content"
      :key="info.label"
      :label="info.label"
      :value="info.value"/>
    <div
      v-if="showDiffBadge"
      class="badge-content">
      <TrendingUpIcon
        v-if="diff > 0"
        :color="color"
        size="small"/>
      <TrendingDownIcon
        v-else-if="diff < 0"
        :color="color"
        size="small"/>
      <TrendingFlatIcon
        v-else
        :color="color"
        size="small"/>
      &nbsp;
      <span :style="badgeStyles">{{ summary }}</span>
    </div>
  </div>
</template>

<script>
import { TrendingUpIcon, TrendingDownIcon, TrendingFlatIcon } from '@mikmak/components';
import BenchmarksTooltipInfo from './BenchmarksTooltipInfo';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    diff: {
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      color: '#778699',
      summary: '',
    };
  },
  computed: {
    badgeStyles() {
      return {
        color: this.color,
      };
    },
    showDiffBadge() {
      return this.diff !== null && this.content.length <= 2;
    },
  },
  components: {
    TrendingUpIcon,
    TrendingDownIcon,
    TrendingFlatIcon,
    BenchmarksTooltipInfo,
  },
  mounted() {
    if (this.diff !== null) {
      const ptsDiff = (this.diff > 0 ? '+' : '') + this.diff.toFixed(1) + ' pts';

      if (this.theme === 'brand') {
        this.summary = this.diff >= 0 ? `${ptsDiff} increase`: `${ptsDiff} decrease`;
      } else {
        this.summary = this.diff >= 0 ? `${ptsDiff} above`: `${ptsDiff} below`;
      }

      if (this.diff !== 0) {
        this.color = this.diff > 0 ? '#00A6A4': '#CB4444';
      }
    }
  },
};
</script>

<style scoped>
  .container-wrapper {
    padding: 12px;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - 24px);
    width: calc(100% - 24px);
  }

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22.4px;
    text-align: left;
    text-transform: capitalize;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .badge-content {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #C1CCD4;
    border-radius: 4px;
    background: #FFFFFF;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    max-height: 28px;
    padding: 6px 8px;
    margin-top: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  hr {
    margin-bottom: 0;
  }
</style>
